module.exports = __webpack_public_path__ + "static/media/swords.e8429f7c.png";